import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

/**
 * Display base for the cross-currency roll-up shown in the Trades MetricsBar pill,
 * the MTM aggregate bar, and the bottom totals footer (LR-469). A single global
 * preference so the EUR/USD toggle in one place re-denominates every roll-up
 * consistently. The native per-currency subtotals never depend on this — only the
 * `≈` convenience total does.
 */
export type DisplayBaseCurrency = 'EUR' | 'USD';

interface CurrencyDisplayStore {
  baseCurrency: DisplayBaseCurrency;
  setBaseCurrency: (currency: DisplayBaseCurrency) => void;
  toggleBaseCurrency: () => void;
}

export const useCurrencyDisplayStore = create<CurrencyDisplayStore>()(
  devtools(
    (set) => ({
      // EUR default: the FX endpoint is EUR-based and the inventory page already
      // reports EUR equivalents, so EUR is the natural house base (LR-469).
      baseCurrency: 'EUR',
      setBaseCurrency: (baseCurrency) => set({ baseCurrency }),
      toggleBaseCurrency: () =>
        set((state) => ({ baseCurrency: state.baseCurrency === 'EUR' ? 'USD' : 'EUR' })),
    }),
    { name: 'currency-display-store', enabled: import.meta.env.DEV },
  ),
);
